import { InvoiceColumn } from '@/context/services/invoice/type';
import { ReceivedInvoiceReadTag } from '@/features/invoices/components/ReceivedInvoiceReadTag/ReceivedInvoiceReadTag';
import { useRenewalUiReceivedInvoicesFlag } from '@/hooks/feature_flag/useRenewalUiReceivedInvoicesFlag';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from '../columns.module.scss';

const cx = classnames.bind(styles);

export type OcrFieldCellProps = {
  formattedValue: string;
  record?: InvoiceColumn;
  alignEnd?: boolean;
};

export const OcrFieldCell: FC<OcrFieldCellProps> = memo(
  ({ formattedValue, record, alignEnd }) => {
    const isRenewalUiReceivedInvoices = useRenewalUiReceivedInvoicesFlag();

    if (!formattedValue) {
      return null;
    }

    if (!isRenewalUiReceivedInvoices) {
      return <>{formattedValue}</>;
    }

    return (
      <div
        className={cx(styles['ocrFieldCell'], {
          [styles['ocrFieldCellAlignEnd']]: alignEnd,
        })}
      >
        <div>{formattedValue}</div>
        <ReceivedInvoiceReadTag
          uploadType={record?.uploadType}
          automaticStatus={record?.automaticStatus}
        />
      </div>
    );
  }
);
OcrFieldCell.displayName = 'OcrFieldCell';
